import axios from '../axios';
import { CustomErrorResponse } from '../types/customError/response';
import { Issuer } from '../types/issuer/response';

/*
  @return {Promise<IssuerResponse | CustomErrorResponse>}
 */
export const getIssuers = async (): Promise<Issuer[] | CustomErrorResponse> => {
  const response = await axios.get('/issuer');

  return response.data.data;
};
